module.exports = __webpack_public_path__ + "img/sports_cmdbet.45b2dce6.png";